let offers;
let product;
let theVariant;
let selectedVariant;
window.selectedOffer = null;
let mulberryPdpInitialized = false;
let mulberryInitPromise;
let mulberryPrefetchPromise;
let pdpUrlListenersBound = false;
let variantPickerInitBound = false;
const mulberryPerfEnabled = false;
let mulberryLoadedResolve;
const mulberryLoadedPromise = new Promise((resolve) => {
  mulberryLoadedResolve = resolve;
});

function runWhenIdle(callback) {
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(callback);
    return;
  }
  window.setTimeout(callback, 200);
}

function markMulberryPerf(label) {
  if (!mulberryPerfEnabled || !window.performance?.mark) {
    return;
  }
  window.performance.mark(label);
}

function isPdpContext() {
  return (
    !!document.querySelector("#pdp-atc") ||
    !!document.querySelector(".mulberry-pdp-inline")
  );
}

async function ensureMulberryPdpReady() {
  if (!isPdpContext()) {
    return false;
  }
  if (mulberryPdpInitialized) {
    return true;
  }
  markMulberryPerf("mulberry:loaded:wait:start");
  await mulberryLoadedPromise;
  markMulberryPerf("mulberry:loaded:wait:end");
  if (mulberryPdpInitialized) {
    return true;
  }
  if (mulberryInitPromise) {
    return mulberryInitPromise;
  }
  mulberryInitPromise = (async () => {
    if (!window.mulberry || !window.mulberryShop) {
      return false;
    }
    await mulberryPdpInit();
    mulberryPdpInitialized = true;
    return true;
  })();
  return mulberryInitPromise;
}

function schedulePdpInit({ eager = false } = {}) {
  const inlineContainer = document.querySelector(".mulberry-pdp-inline");
  markMulberryPerf("mulberry:init:schedule");
  prefetchMulberryOffers();
  if (eager) {
    ensureMulberryPdpReady();
    return;
  }
  if (!inlineContainer) {
    runWhenIdle(() => {
      ensureMulberryPdpReady();
    });
    return;
  }

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          observer.disconnect();
          ensureMulberryPdpReady();
        }
      },
      { rootMargin: "200px 0px" }
    );
    observer.observe(inlineContainer);
    return;
  }

  runWhenIdle(() => {
    ensureMulberryPdpReady();
  });
}

// window.abModalVariant = 11;
function getCurrentlySelectedVariant(product) {
  let selectedVariant = null;
  if(product) {
    selectedVariant = product.variants.find((i) => i.id == mulberryShop.selectedVariantId);
    if (!selectedVariant) {
      selectedVariant = product.variants[0];
    }
    mulberryShop.selectedVariantId = selectedVariant.id;    
  }
  return selectedVariant;
}

async function mulberryPdpInit() {
  if (mulberryPdpInitialized) {
    return;
  }
  markMulberryPerf("mulberry:init:start");

  const HAS_MODAL = mulberry?.core?.settings?.has_modal ?? true;
  const HAS_INLINE = mulberry?.core?.settings?.has_inline ?? true;

  await prefetchMulberryOffers();
  if (!product || !offers) {
    return;
  }


  if (HAS_INLINE && document.querySelector(".mulberry-pdp-inline")) {
    markMulberryPerf("mulberry:inline:init:start");
    window.pdpInline = await mulberry.inline.init({
      offers: offers,
      settings: mulberry.core.settings,
      selector: ".mulberry-pdp-inline",
      onWarrantyToggle: async (warranty) => {
        mulberry.inline.isSelected = warranty.isSelected;
        if (warranty.isSelected) {
          window.selectedOffer = warranty;
        } else {
          window.selectedOffer = null;
        }
      },
    });
    markMulberryPerf("mulberry:inline:init:end");
  }
  
  if (HAS_MODAL) {
    markMulberryPerf("mulberry:modal:init:start");
    window.pdpModal = await mulberry.modal.init({
      offers: offers,
      settings: mulberry.core.settings,
      onWarrantySelect: async (warranty) => {
        const result = await mulberryShop.getWarrantyVariant(warranty);
        await mulberryShop.addWarrantyToCart(
          result.shopify_variant_id,
          {
            ...product,
            title: product.title,
            variantId: mulberryShop.selectedVariantId,
            quantity: parseInt(document.querySelector('#productQuantity').value)
          },
          warranty
        );
        mulberry.modal.close();
        document?.querySelector("#pdp-atc").removeAttribute('disabled');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }))
      },
      onWarrantyDecline: async () => {
        mulberry.modal.close();
        document?.querySelector("#pdp-atc").removeAttribute('disabled');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }))
      },
    });
    markMulberryPerf("mulberry:modal:init:end");
  }

  document.addEventListener("variant:change", async function (e) {
    window.selectedOffer = null;
    if (window.pdpModal) {
      window.pdpModal.updateOffer([]);
    }
    selectedVariant = e.detail.variant;
    offers = await mulberry.core.getWarrantyOffer({
      id: selectedVariant.id,
      title: product.title,
      price: `${(selectedVariant.compare_at_price/100).toFixed(2)}`,
      detail: product,
    });
    if (window.pdpInline) {
      window.pdpInline.updateOffer(offers);
    }
    if (window.pdpModal) {
      window.pdpModal.updateOffer(offers);
    }
  });

  setupPdpUrlListeners();
  markMulberryPerf("mulberry:init:end");
}

document
  ?.querySelector("#pdp-atc")
  ?.addEventListener("click", async function (ev) {
    const isReady = await ensureMulberryPdpReady();
    if (!isReady) {
      return;
    }
    const handleClick = async () => {
      ev.target.setAttribute('disabled', '');
      const HAS_MODAL = mulberry?.core?.settings?.has_modal ?? true;
      const HAS_INLINE = mulberry?.core?.settings?.has_inline ?? true;

      if (HAS_INLINE && window.selectedOffer) {
        await addWarranty();
      }
      else if (HAS_MODAL && window.pdpModal && !window.selectedOffer) {
        window.pdpModal.open();
      }
    };

    await Promise.resolve().then(handleClick);
  });

async function addWarranty() {
  addToCartButtonClicked = true;
  if (!offers || offers.length == 0) {
    return;
  }
  try {
    let result;
    cart = await fetch("/cart.js");
    cartJson = await cart.json();
    if (window.selectedOffer) {
      result = await mulberryShop.getWarrantyVariant(
        window.selectedOffer.offer
      );
      const final = await mulberryShop.addWarrantyToCart(
        result.shopify_variant_id,
        {
          ...product,
          title: product.title,
          variantId: mulberryShop.selectedVariantId,
          quantity: parseInt(document.querySelector('#productQuantity').value)
        },
        window.selectedOffer.offer
      );
      document?.querySelector("#pdp-atc").removeAttribute('disabled');
      window.selectedOffer = null;
      if (window.pdpInline) {
        window.pdpInline.deselectOffer();
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }))
    }
  } catch (err) {
    console.log("mulberry error: ", err);
  }
}

document.addEventListener("mulberry-shopify:loaded", async function (e) {
  window.mb_gtm_is_disabled = true
  setupFetchListeners();
  if (mulberryLoadedResolve) {
    mulberryLoadedResolve();
  }

  if (isPdpContext()) {
    schedulePdpInit({ eager: true });
    bindVariantPickerInit();
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        schedulePdpInit({ eager: true });
      });
    }
  }

  runWhenIdle(() => {
    removeAndSyncWarranties().catch((error) => {
      console.error('Error during warranty removal and cart sync:', error);
    });

    if (mulberryShop?.cart?.init) {
      mulberryShop.cart
        .init()
        .then(() => mulberryShop.cart.render())
        .catch((error) => {
          console.error('Error during cart init/render:', error);
        });
    }
  });
});

if (window.mulberry && window.mulberryShop && mulberryLoadedResolve) {
  mulberryLoadedResolve();
}

async function removeAndSyncWarranties(reload = false) {
  let response = await fetch('/cart.js', {
    credentials: 'same-origin',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  });

  let firstCart = await response.json();
  const originalItemCount = firstCart.item_count;

  // Filter items
  firstCart.items = firstCart.items.filter(
    item => item?.properties?._variantId !== 'sectional'
  );

  try {
    const newCart = await mulberryShop.removeDetachedWarranty(firstCart);
    const updatedCart = await mulberryShop.cart.syncQuantities(newCart);

  } catch (error) {
    console.error('Error during warranty removal and cart sync:', error);
  }
}

async function prefetchMulberryOffers() {
  if (!isPdpContext()) {
    return null;
  }
  if (offers) {
    return offers;
  }
  if (mulberryPrefetchPromise) {
    return mulberryPrefetchPromise;
  }

  mulberryPrefetchPromise = (async () => {
    await mulberryLoadedPromise;
    if (!window.mulberry || !window.mulberryShop) {
      return null;
    }
    markMulberryPerf("mulberry:offers:fetch:start");
    let response = await mulberryShop.getProductData(
      mulberryShop.getProductUrl()
    );
    product = response.product;
    let initSelection = getCurrentlySelectedVariant(product);
    if (initSelection) {
      theVariant = initSelection.id;
    }
    selectedVariant = getCurrentlySelectedVariant(product);
    offers = await mulberry.core.getWarrantyOffer({
      id: selectedVariant.id,
      title: product.title,
      price: selectedVariant.compare_at_price,
      detail: product,
    });
    markMulberryPerf("mulberry:offers:fetch:end");
    return offers;
  })();

  return mulberryPrefetchPromise;
}

function setupPdpUrlListeners() {
  if (pdpUrlListenersBound) {
    return;
  }
  pdpUrlListenersBound = true;

  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
  
  async function handleUrlChange() {
    var variant = getUrlParameter('variant');
    if (variant && theVariant !== variant) {
      theVariant = variant
      window.selectedOffer = null;
      mulberryShop.selectedVariantId = variant
      selectedVariant = getCurrentlySelectedVariant(product);

      if(selectedVariant) {
        offers = await mulberry.core.getWarrantyOffer({
          id: selectedVariant.id,
          title: product.title,
          price: selectedVariant.compare_at_price,
          detail: product,
        });
        if (window.pdpInline) {
          window.pdpInline.updateOffer(offers);
        }
        if (window.pdpModal) {
          window.pdpModal.updateOffer(offers);
        }
      }
    }
  }

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'href') {
        handleUrlChange();
      }
    });
  });

  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['href']
  });

  ['click', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (e.target.closest('.radio-group__color') || e.target.closest('.option-groups__group')) {
        setTimeout(() => {
          handleUrlChange();
        }, 100)
      }
    }, { passive: true });
  });
  
  handleUrlChange();
}

function bindVariantPickerInit() {
  if (variantPickerInitBound) {
    return;
  }
  variantPickerInitBound = true;

  const eagerInit = () => {
    schedulePdpInit({ eager: true });
  };

  document.addEventListener("variantPicker:ready:handle", eagerInit);
  document.addEventListener("changeVariant", eagerInit);
}


function setupFetchListeners() {
  const { fetch: origFetch } = window;
  window.fetch = async (...args) => {
    const response = await origFetch(...args);
    let requestUrl = args[0];
    if (typeof requestUrl === 'string') {
      requestUrl = requestUrl.toString();
      if (requestUrl.includes("cart/change")) {
        response
          .clone()
          .json()
          .then(async (body) => {
            await removeAndSyncWarranties();
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }))
          })
          .catch((err) => console.error(err));
      }
    }
    return response;
  };
}